import { getIconByKey } from 'utils/iconRegistry';
import { pascalToSnake } from 'utils/formatters';
import Image from 'next/image';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import type { CardContentProps } from './types';

export const CardContent = ({ cardCopy, listItems, isContentHidden }: CardContentProps) => {
  return (
    <>
      <div className="font-serif text-body-serif">
        <RichTextCopy copy={cardCopy} />
      </div>
      <ul aria-hidden={isContentHidden} className="font-sans font-semibold">
        {listItems.map((item, index) => {
          const iconName = pascalToSnake(item.iconName ?? '');
          const Icon = getIconByKey(iconName);

          return (
            <li key={item.sys?.id ?? index} className="flex items-center gap-3 pb-4">
              <div className="flex items-center justify-center w-6 h-6">
                {Icon && <Icon data-testid="linkedIcon" />}
                {item.icon && (
                  <Image src={item.icon.url} alt={item.icon.title} height={24} width={24} loading="lazy" />
                )}
              </div>
              <RichTextCopy copy={item.copy} />
            </li>
          );
        })}
      </ul>
    </>
  );
};
